// extracted by mini-css-extract-plugin
export default {"container":"OW-z","title":"PW-z","link":"QW-z"};